// extracted by mini-css-extract-plugin
module.exports = {"shopify-invalid-content":"shopify-invalid-content-1xvYuV6"};